"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveCustomTableViewsWatcher = saveCustomTableViewsWatcher;

var _effects = require("redux-saga/effects");

var actions = _interopRequireWildcard(require("./actions"));

var types = _interopRequireWildcard(require("./types"));

var _apiRequest = require("../../api/apiRequest");

var _data = require("../../../../constants/data");

var _actions2 = require("../loadAll/actions");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(saveCustomTableViewsWorker),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(saveCustomTableViewsWatcher);

function saveCustomTableViewsWorker(action) {
  var tableViewConfig;
  return regeneratorRuntime.wrap(function saveCustomTableViewsWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          tableViewConfig = action.payload.tableViewConfig;
          _context.prev = 1;
          _context.next = 4;
          return (0, _effects.put)(actions.start());

        case 4:
          _context.next = 6;
          return (0, _effects.call)(_apiRequest.apiRequest, _data.DATA_URLS.CUSTOM_TABLE_VIEW_SAVE_URL, "POST", {
            body: tableViewConfig
          });

        case 6:
          _context.next = 8;
          return (0, _effects.put)((0, _actions2.saga)());

        case 8:
          _context.next = 10;
          return (0, _effects.put)(actions.success());

        case 10:
          _context.next = 17;
          break;

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](1);
          console.error(_context.t0);
          _context.next = 17;
          return (0, _effects.put)(actions.failure());

        case 17:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 12]]);
}

function saveCustomTableViewsWatcher() {
  return regeneratorRuntime.wrap(function saveCustomTableViewsWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(types.SAGA, saveCustomTableViewsWorker);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}